import floorHtmlTemplate from "./FloorPage.ejs"
import sectionsMapMenu from "../../components/SectionsMapMenu/SectionsMapMenu";
import sectionsMapView from "../../components/SectionsMapView/SectionsMapView";
import makeTemplateFunc from "lodash/template"
import { Preloader, housingNav } from "../../components"
import { SECTION_PAGE, FLOOR_PAGE, FLAT_PAGE } from "../../routes"
import {
    getFloor,
    registerPreloader
} from "../../api"
import $ from "jquery";
import "../../components/CallbackPopup/CallbackPopup";

const floorTemplateFunc = makeTemplateFunc(floorHtmlTemplate);

export class FloorPage {
    constructor($container, params, app) {
        this.selectedFlat = params.selectedFlat;
        this.$container = $container;
        this.params = params;
        this.app = app;
        registerPreloader(new Preloader(this.$container))
    }

    render() {
        getFloor(this.app.apiPaths.FLOOR_DETAIL, this.params).then((response) => this.renderPage(response));
    }

    renderPage(response) {
        this.$container.addClass('h100');
        this.$container.html(floorTemplateFunc({
            response: response,
            selectedFlat: this.selectedFlat
        }));
        sectionsMapMenu.render(this.$container.find('.js-sections-map-menu'), response);
        sectionsMapView.render(this.$container.find('.js-sections-map-view'), response);

        // handleSections
        this.$container.find('.js-section-field').on('click', this.app.handleSectionClick.bind(this));
        this.$container.find('.js-get-section').on('click', this.app.handleSectionClick.bind(this));

        // handleFloor
        this.$container.find('.js-get-flat').on('click', this.app.handleFlatClick.bind(this));
        this.$container.find('.js-get-floor').on('click', this.app.handleFloorClick.bind(this));

        this.app.svgLight('.under-light');

        this.app.initScroll();

        housingNav.actualize(response.responseJSON.prevHousing, response.responseJSON.nextHousing);

        $('.js-expand-right-col').click((e) => this.app.handleRightColExpand(e));
    }

}



// WEBPACK FOOTER //
// ./js/pages/FloorPage/FloorPage.js